import styled from 'styled-components'
import { inputgray, darkblue, white, red, black } from '../../styles/colors'
import { minmedia } from '../../styles/media-queries'

export const Cta = styled.div`
  background: linear-gradient(to right, ${inputgray}, ${darkblue});
  padding: 0 1rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin-bottom: 1.5rem;
  height: 250px;
  width: 100%;
  ${minmedia.large`
    margin-bottom: 0;
    padding: 0 3rem;
    height: 350px;
  `};
`

export const Half = styled.div`
  width: 100%;
  ${minmedia.large`
  width: calc(50% - 0.5rem);
`};
  ${minmedia.xmlarge`
  width: calc(50% - 2rem);
`};
`

export const Background = styled.div`
  width: ${props => (props.employee ? '40%' : '100%')};
  height: ${props => (props.employee ? 'calc(100% + 2rem)' : '100%')};
  background-size: ${props => (props.employee ? 'contain' : 'cover')};
  background-position: ${props => (props.employee ? 'bottom' : 'center')};
  margin-top: ${props => (props.employee ? '-2rem' : '0')};
  position: ${props => (props.employee ? 'relative' : 'absolute')};
  background-repeat: no-repeat;
  left: 0;
  top: 0;
`

export const ContentContainer = styled.div`
  text-align: center;
  width: ${props => (props.employee ? '50%' : '100%')};
  position: relative;
  z-index: 3;
`

export const Title = styled.div`
  color: ${white};
  font-size: 24px;
  margin: 0 auto;
  margin-bottom: 0.5rem;
  font-weight: 700;
  max-width: 400px;
  ${minmedia.medium`
    font-size: ${props => (props.employee ? '30px' : '35px')};
  `};
`

export const Subtitle = styled.div`
  font-size: 22px;
  color: ${white};
  ${minmedia.medium`
    font-size: 24px;
  `};
`

export const Button = styled.a`
  transition: all 0.5s;
  text-decoration: none;
  display: inline-block;
  color: ${white};
  background: ${red};
  font-size: 18px;
  padding: 0.75rem 2rem;
  border-radius: 0.25rem;
  margin-top: 1.5rem;
  ${minmedia.medium`
    font-size: 22px;
  `};
  &:hover {
    background: ${black};
  }
`



// WEBPACK FOOTER //
// ./src/components/DoubleCTA/styles.js